import React from 'react';
import style from './style.less';

const HeaderPageDescription = ({ children, className = '' }) => (
	<div className={`${style.header_page_container} ${className ? className : ''}`}>{ children }</div>
);

export default HeaderPageDescription;
